import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
} from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { map, catchError, take } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngrx/store';
import * as fromRoot from '../../reducers';
import * as authActions from '../../core/actions/auth';
import { UserService } from './userService';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable()
export class HttpConfigInterceptor implements HttpConfigInterceptor {
  constructor(
    private store: Store<fromRoot.State>,
    private userService: UserService,
    private translate: TranslateService,
    private snackBar: MatSnackBar
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      map((event: HttpEvent<any>) => event),
      catchError((error: HttpErrorResponse) => {
        const isCurrentUser = error.url.indexOf('current-user') !== -1;
        const isCheckToken = error.url.indexOf('token-auth') !== -1;
        const isBillingExpired = error.url.indexOf('billing-account') !== -1;
        if (
          (error.status === 401 && isCheckToken) ||
          isCurrentUser ||
          isBillingExpired
        ) {
          localStorage.removeItem('id_token');
          this.store.dispatch(new authActions.Logout());
          this.userService.logout();

          this.translate
            .get('auth_session_expired')
            .pipe(take(1))
            .subscribe(msg => {
              this.snackBar.open(msg, null, {
                duration: 3000,
              });
            });
        }
        return throwError(error);
      })
    );
  }
}
